import {AfterViewInit, Component, OnInit} from '@angular/core';
import {MenuItem} from './ui-components/nav-bar/nav-bar.component';
import {TranslateService} from '@ngx-translate/core';
import {select, Store} from '@ngrx/store';
import {State} from './pages/landingpage/store/reducer/landingpage.reducer';
import {loadUserStart} from './pages/landingpage/store/actions/getUser.actions';
import {Router} from '@angular/router';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {Security} from './security';
import {Observable, of} from 'rxjs';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  public title = 'myDay';

  public user;

  public firmaId;

  // tslint:disable-next-line:variable-name
  constructor(private store: Store<{ landingpage: State }>, private translate: TranslateService, public router: Router, public http: HttpClient, public security: Security) {
    translate.setDefaultLang('de-DE');
    translate.use('de-DE');
    this.user = store.pipe(select((state) => state.landingpage.items));
    this.firmaId = store.pipe(select((state) => state.landingpage.items.firmaId));
  }


  // tslint:disable-next-line:use-lifecycle-interface
  public ngOnInit(): void {


    if (sessionStorage.getItem('email') != null){
      const email = sessionStorage.getItem('email');
      this.store.dispatch(loadUserStart({email}));
    }


  }
}
